import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class StaticPagesService {

  constructor(private http: HttpClient, private utils: UtilsService) { }

  getStaticPageByName(data: any) {
    return this.http.get(`${this.utils.apiUrl}StaticPageData/GetStaticPageDataByPageName?pageName=${data.pageName}`, data)
      .pipe(catchError(this.utils.processError.bind(this)))
  }

  getStaticPageList(data: any) {
    return this.http.get(`${this.utils.apiUrl}StaticPageData/GetStaticPageMultipleDocUploadDataByPageName?pageName=${data.pageName}`, data)
      .pipe(catchError(this.utils.processError.bind(this)))
  }

  getStaticPageData(): Observable<any> {
    let url = this.utils.apiUrl + 'StaticPageData/GetStaticPageData';
    return this.http.get(url, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }

  addBulkOrderEnquiry(body: any): Observable<any> {
    let url = this.utils.apiUrl + 'Enquiry/AddBulkOrderEnquiry';
    return this.http.post(url, body).pipe(catchError(this.utils.processError.bind(this)));
  }
}
